export default __webpack_public_path__ + "static/media/email-icon.a5eb0db1.svg";